import React from 'react'
import { ButtonBase, Card, Typography } from '@mui/material'
import { kpiCardSx } from '../../../common/sharedStyles'

/** A KPI card; clickable (with a selected state and a "Click to view" hint) when onClick is given. */
export default function KpiTile({ label, value, sub, accent = 'primary', onClick, selected, hint = 'Click to view' }) {
  const body = (
    <>
      <Typography sx={{ fontSize: 11, fontWeight: 600, letterSpacing: '.04em', textTransform: 'uppercase', color: 'text.secondary' }} noWrap>{label}</Typography>
      <Typography sx={{ fontSize: 22, fontWeight: 800, lineHeight: 1.3, fontVariantNumeric: 'tabular-nums' }} noWrap>{value}</Typography>
      {sub && <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>{sub}</Typography>}
      {onClick && <Typography sx={{ fontSize: 11, fontWeight: 600, color: 'primary.main', mt: 0.5 }}>{selected ? 'Showing these ✓' : `${hint} ›`}</Typography>}
    </>
  )
  const sx = { ...kpiCardSx(accent), p: 1.75, display: 'block', textAlign: 'left', bgcolor: 'background.paper', width: '100%',
    ...(selected ? { borderColor: 'primary.main', boxShadow: '0 0 0 2px rgba(32,101,209,.15)' } : {}) }
  if (!onClick) return <Card elevation={0} sx={sx}>{body}</Card>
  return <ButtonBase component={Card} elevation={0} onClick={onClick} aria-pressed={!!selected} sx={sx}>{body}</ButtonBase>
}
